// extracted by mini-css-extract-plugin
export var fadeInOut = "_3o-3";
export var icon = "_3o-4";
export var savedIndicator = "_3o-2";
export var savingIndicator = "_3o-0";
export var spin = "_3o-1";